import * as React from "react";

export class PrivacyPolicyPage extends React.Component {
  componentWillMount(){
    window.location.href = "https://drive.google.com/a/seas.upenn.edu/file/d/14iAL1C3-RcCo8adwVpHhRthWJDRYXVyw/view?usp=sharing";
  }
  render(){
    return (<section>Redirecting...</section>);
  }
}

export default PrivacyPolicyPage;


// WEBPACK FOOTER //
// ./src/pages/PrivacyPolicy/PrivacyPolicyPage.tsx